@if (data$ | async; as data) {
  @if (getItems() | async; as items) {
    <app-uig-carousel
      [items]="items"
      [template]="template"
      timeout="{{data.timeout}}"
      itemWidth="100%"
      class="inline-navigation"
    ></app-uig-carousel>
  }
}

<ng-template #template let-item="item">
  <ng-container
    [cxComponentWrapper]="{
      flexType: item.typeCode,
      typeCode: item.typeCode,
      uid: item?.uid
    }"
    >
  </ng-container>
</ng-template>
